module.exports = __webpack_public_path__ + "img/facebook.dc675841.png";